import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import themes from '../../theming/themes.js';
import React, { memo, useState, useRef, useEffect } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import { DropdownContext } from './DropdownContext.js';
import DropdownButton from './_DropdownButton.js';
import DropdownContainer from './_DropdownContainer.js';
import DropdownMenu from './_DropdownMenu.js';

var _excluded = ["buttonText", "buttonTextColor", "buttonTextSize", "dropdownItems", "iconSize", "isPinnedRight", "theme", "renderButton"];
var navigateToSubMenuItems = function navigateToSubMenuItems(firstSubMenuItemRef) {
  return function () {
    var subMenuItem = firstSubMenuItemRef.current;
    subMenuItem.focus();
  };
};
var Dropdown = function Dropdown(_ref) {
  var _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? '' : _ref$buttonText,
    _ref$buttonTextColor = _ref.buttonTextColor,
    buttonTextColor = _ref$buttonTextColor === void 0 ? 'black' : _ref$buttonTextColor,
    _ref$buttonTextSize = _ref.buttonTextSize,
    buttonTextSize = _ref$buttonTextSize === void 0 ? 'medium' : _ref$buttonTextSize,
    dropdownItems = _ref.dropdownItems,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? 'xs' : _ref$iconSize,
    _ref$isPinnedRight = _ref.isPinnedRight,
    isPinnedRight = _ref$isPinnedRight === void 0 ? false : _ref$isPinnedRight,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? themes["default"] : _ref$theme,
    renderButton = _ref.renderButton,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var dropdownButton = useRef(null);
  var firstSubMenuItem = useRef(null);
  useEffect(function () {
    setIsOpen(false);
  }, [dropdownItems]);
  var context = {
    buttonText: buttonText,
    firstSubMenuItem: firstSubMenuItem,
    iconSize: iconSize,
    isOpen: isOpen,
    navigateToSubMenuItems: navigateToSubMenuItems(firstSubMenuItem),
    setIsOpen: setIsOpen,
    theme: theme,
    toggleMenu: function toggleMenu() {
      return setIsOpen(!isOpen);
    }
  };
  return /*#__PURE__*/React.createElement(DropdownContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(DropdownContainer, _extends({}, rest, {
    role: 'menu'
  }), /*#__PURE__*/React.createElement(DropdownButton, {
    buttonTextColor: buttonTextColor,
    buttonTextSize: buttonTextSize,
    renderButton: renderButton,
    ref: dropdownButton
  }), /*#__PURE__*/React.createElement(DropdownMenu, {
    isPinnedRight: isPinnedRight,
    dropdownItems: dropdownItems,
    dropdownButtonRef: dropdownButton,
    theme: theme
  })));
};
var _Dropdown = withDefaultTheme(/*#__PURE__*/memo(Dropdown));

export default _Dropdown;
export { Dropdown };
